import cookies from 'vue-cookies';

/**
 * This file holds computed state properties
 * Please refer to https://vuex.vuejs.org/guide/getters.html for more information
 */

const getters = {
  getCookieByCampaignId: () => (campaignId) => {
    return cookies.get(`customs_campaign_id_${campaignId}`);
  }
};
export default getters;
